module.exports = require("react-pubsub-via-radio.js/radio");



//////////////////
// WEBPACK FOOTER
// ./~/ES/lib/radio.js
// module id = 5
// module chunks = 0 1 2 3 4